import { Box, Button, Typography } from '@mui/material';
import { Link } from "react-router-dom";

const Notfound = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: "#3f4652",
      }}
    >
      <Typography variant="h1" style={{ color: 'white' }}>
        404
      </Typography>
      <Typography variant="h6" style={{ color: 'white' }}>
        Page Not Found
      </Typography>
      <Button variant="contained">
        <Link to="/" style={{ textDecoration: "none" }}>
          Back Home
        </Link>

      </Button>
    </Box>
  );
};

export default Notfound;
